import { motion } from "framer-motion";

const points = [
  "AI-powered analysis tuned for medical report patterns",
  "Real-time insights with trend and risk visibility",
  "Secure architecture for sensitive health records",
  "Easy sharing with family and care teams",
  "Clean UX designed for clarity and confidence"
];

export default function WhyBestSection() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-16 md:px-10">
      <div className="rounded-3xl border border-indigo-100 bg-gradient-to-br from-indigo-50 to-cyan-50 p-8 shadow-sm">
        <h2 className="mb-5 text-3xl font-bold text-gray-900">Why We Are Best</h2>
        <div className="grid gap-3 md:grid-cols-2">
          {points.map((point, index) => (
            <motion.div
              key={point}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.07 }}
              className="rounded-2xl bg-white/80 p-4 text-gray-700"
            >
              {point}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
